// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aside-content-login {
  width: 100%;
  height: 100vh;
}

video {
  width: 100%;
  height: 100vh;
  object-fit: fill;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/home-aside-content/home-aside-content.component.scss","webpack://./src/components/general%20components/home-aside-content/home-aside-content.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;ACCF;;ADEA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;ACCF","sourcesContent":[".aside-content-login {\n  width: 100%;\n  height: 100vh;\n}\n\nvideo {\n  width: 100%;\n  height: 100vh;\n  object-fit: fill;\n}\n",".aside-content-login {\n  width: 100%;\n  height: 100vh;\n}\n\nvideo {\n  width: 100%;\n  height: 100vh;\n  object-fit: fill;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
